import React from 'react';
import PropTypes from 'prop-types';
import { PublicTimeLineContainer } from './styles';

function PublicTimeLine({ items, currentScreen, progress }) {
  /**
   * @items -> array of screens to map. each object in the
   * array contains name - reference of the screen, screenName - label of the screen
   * Other properties can be added to array on a required basis
   * @currentScreen -> Name of the form that user is interacting with currently
   * @progress -> the progress of whole nium forex form process
   */
  return (
    <PublicTimeLineContainer marginTop={25} marginBottom={80} width={progress}>
      <div className="timeline-progress"></div>
      <div className="timeline-items">
        {items?.map((item, index) => (
          <div
            key={index}
            className={`timeline-item ${
              currentScreen?.toLowerCase().includes(item?.name?.toLowerCase()) ? 'active' : ''
            }`}
          >
            <div className="timeline-content">{item?.screenName}</div>
          </div>
        ))}
      </div>
    </PublicTimeLineContainer>
  );
}

PublicTimeLine.propTypes = {
  items: PropTypes.array,
  currentScreen: PropTypes.string,
  progress: PropTypes.number
};

export default PublicTimeLine;
